import Dropdown from "../common/dropdown/Dropdown";
import { INDIAN_BUDGET_UNITS } from "../../data/countries";

export default function BudgetInput({
  label,
  value,
  unit,
  units = INDIAN_BUDGET_UNITS,
  onValueChange,
  onUnitChange,
  error,
  required,
}) {
  return (
    <div className={`form-item ${error ? "has-error" : ""}`}>
      <label className="form-label">
        {label}
        {required && <span className="required">*</span>}
      </label>

      <div className="budget-input-wrapper d-flex align-center gap-2">
        <input
          type="number"
          value={value}
          onChange={(e) => onValueChange(e.target.value)}
          className="form-input"
          placeholder="Enter amount"
        />

        <Dropdown
          options={Object.keys(units)}
          value={unit}
          onChange={onUnitChange}
        />
      </div>

      {error && <p className="form-error">{error}</p>}
    </div>
  );
}
